import { Box, Grid, Heading, Text } from "@chakra-ui/react";
import { useRef, useState } from "react";
import { Reveal, SectionHead } from "@/components";
import { KNIT_SHAPING_HEAD, KNIT_SHORT_ROWS, KNIT_SHORT_ROWS_ON_SUZANNE } from "@/content";
import { KnitmapCloseUp } from "./knit/KnitmapCloseUp";
import { ShortRowSwatch, type ShortRowSwatchHandle } from "./knit/ShortRowSwatch";
import { StepList } from "./knit/StepList";

const { regions } = KNIT_SHORT_ROWS_ON_SUZANNE;

export const KnittingShaping = () => {
  const swatchRef = useRef<ShortRowSwatchHandle>(null);
  const [step, setStep] = useState(0);

  return (
    <Box as="section" id="shaping" maxW="maxw" mx="auto" px="pad" pb="sec">
      <SectionHead head={KNIT_SHAPING_HEAD} />

      <Grid
        templateColumns={{ base: "minmax(0, 1fr)", lg: "minmax(0, 1.15fr) minmax(0, 0.85fr)" }}
        gap="clamp(32px, 4vw, 56px)"
        alignItems="start"
      >
        <ShortRowSwatch ref={swatchRef} onStepChange={setStep} />
        <StepList
          label={KNIT_SHORT_ROWS.stepsLabel}
          steps={KNIT_SHORT_ROWS.steps}
          active={step}
          onSelect={(index) => swatchRef.current?.showStep(index)}
        />
      </Grid>

      <Box mt="clamp(56px, 7vw, 104px)">
        <Heading as="h3" variant="card">
          {KNIT_SHORT_ROWS_ON_SUZANNE.title}
        </Heading>
        <Text variant="body" maxW="62ch" mt="12px" sx={{ textWrap: "pretty" }}>
          {KNIT_SHORT_ROWS_ON_SUZANNE.intro}
        </Text>

        <Grid
          templateColumns={{ base: "minmax(0, 1fr)", md: "repeat(3, minmax(0, 1fr))" }}
          gap="gap"
          mt="clamp(24px, 3vw, 40px)"
        >
          {regions.map((region, index) => (
            <Reveal
              key={region.id}
              index={index}
              as="article"
              display="grid"
              gridTemplateRows="auto 1fr"
              borderRadius="lg"
              overflow="hidden"
              bg="surface.white"
              border="1px solid"
              borderColor="line.hairline"
            >
              <img
                src={region.image.src}
                width={region.image.width}
                height={region.image.height}
                alt={region.image.alt}
                loading="lazy"
                decoding="async"
                style={{ width: "100%", height: "auto", aspectRatio: "1 / 1", objectFit: "cover" }}
              />
              <Grid
                gap="12px"
                p="clamp(20px, 2.2vw, 30px)"
                alignContent="start"
                borderTop="1px solid"
                borderColor="line.hairline"
              >
                <Heading as="h4" variant="card">
                  {region.title}
                </Heading>
                <Text variant="body" sx={{ textWrap: "pretty" }}>
                  {region.body}
                </Text>
                <Box mt="6px" border="1px solid" borderColor="line.hairline">
                  <KnitmapCloseUp from={region.courses.from} to={region.courses.to} alt={region.knitmapAlt} />
                </Box>
              </Grid>
            </Reveal>
          ))}
        </Grid>
      </Box>
    </Box>
  );
};
